export const TOOLTIPS = {
    PAID_MARKETING: 'Switch the toggle ON to add your domain to<br/>ClickCease Paid Marketing protection.<br/>You will still need to configure the domain there.',
    MONITORING: 'When the domain is set <br/> to monitoring mode, Bot Zapping will <br/> only detect, not block, bots.'  
}